import store from '@/store'
export default [
  {
    path: '/roles',
    name: 'role',
    meta: { requiresAuth: true },
    component: () => import('@/pages/role/index.vue')
  },
  {
    path: '/roles/create',
    name: 'role-create',
    meta: { requiresAuth: true },
    component: () => import('@/pages/role/create.vue')
  },
  {
    path: '/roles/:id',
    name: 'role-edit',
    meta: { requiresAuth: true },
    component: () => import('@/pages/role/edit.vue'),
    beforeEnter: async (to, from, next) => {
      await store.dispatch('role/find', to.params.id)
      next()
    }
  }
]
